import type { $Fetch } from "ofetch";
import {
  DEFAULT_AUD,
  URL_FETCH_OTP_BY_PHONE,
  URL_VERIFY_OTP_CODE,
  URL_AUTHORIZE,
  URL_REFRESH_TOKENS,
  URL_PROFILE,
  URL_CHECK_USER_PROFILE,
  URL_REGISTER,
} from "../constants";
import type {
  IFetchOTPCodeBody,
  IFetchOTPCodeResponse,
  IVerifyOTPCodeBody,
  IVerifyOTPCodeResponse,
  IAuthorizeUserBody,
  IAuthorizeUserResponse,
  IRefreshTokensBody,
  IProfileResponse,
  IRegisterBody,
  ExtraFetchOptions,
} from "../types";

declare module "ofetch" {
  interface FetchOptions extends ExtraFetchOptions {}
}

export const authFetchOtpCodeByPhone = (
  transport: $Fetch,
  payload: IFetchOTPCodeBody,
) => {
  const body = {
    aud: payload.aud ?? DEFAULT_AUD,
    "captcha-token": payload.captchaToken,
    phone: payload.phoneNumber.replace(/\D/g, ""),
  };
  return transport<IFetchOTPCodeResponse>(URL_FETCH_OTP_BY_PHONE, {
    method: "POST",
    gateway: "magnit-id",
    body,
  });
};

export const authVerifyOtpCode = (
  transport: $Fetch,
  payload: IVerifyOTPCodeBody,
) => {
  const body = {
    aud: payload.aud ?? DEFAULT_AUD,
    code: payload.code,
    attemptId: payload.attemptId,
    phone: payload.phoneNumber.replace(/\D/g, ""),
  };
  return transport<IVerifyOTPCodeResponse>(URL_VERIFY_OTP_CODE, {
    method: "POST",
    gateway: "magnit-id",
    body,
  });
};

export const authAuthorizeUser = (
  transport: $Fetch,
  payload: IAuthorizeUserBody,
) => {
  const body = {
    aud: payload.aud ?? DEFAULT_AUD,
    magnitIDCode: payload.magnitIDCode,
  };
  return transport<IAuthorizeUserResponse>(URL_AUTHORIZE, {
    method: "POST",
    gateway: "magnit-id",
    body,
  });
};

export const authRefreshTokens = (
  transport: $Fetch,
  payload: IRefreshTokensBody,
) => {
  const body = {
    aud: payload.aud ?? DEFAULT_AUD,
    refreshToken: payload.refreshToken,
  };
  return transport<IAuthorizeUserResponse>(URL_REFRESH_TOKENS, {
    method: "POST",
    gateway: "magnit-id",
    body,
  });
};

export const authFetchProfile = (transport: $Fetch) => {
  return transport<IProfileResponse>(URL_PROFILE, {
    method: "GET",
    gateway: "magnit-id",
    permissions: {
      jwt: true,
    },
  });
};

export const authCheckUserProfile = (transport: $Fetch) => {
  return transport<void>(URL_CHECK_USER_PROFILE, {
    method: "GET",
    gateway: "magnit-id",
    permissions: {
      jwt: true,
    },
  });
};

export const authRegister = (transport: $Fetch, body: IRegisterBody) => {
  return transport<IProfileResponse>(URL_REGISTER, {
    gateway: "magnit-id",
    method: "POST",
    body,
  });
};

export const authExchangeExternalToken = (transport: $Fetch, token: string) => {
  return transport<IAuthorizeUserResponse>(URL_REGISTER, {
    method: "POST",
    gateway: "magnit-id",
    body: {
      token,
      aud: "loyalty-web",
    },
    permissions: {
      jwt: true,
    },
  });
};
